import { render, staticRenderFns } from "./all-plan.vue?vue&type=template&id=5f491540&scoped=true&"
import script from "./all-plan.vue?vue&type=script&lang=js&"
export * from "./all-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f491540",
  null
  
)

export default component.exports